import { protectedApi } from "../common/protectedApi";
import { APIS } from "../constants/apiConstant";

export const mapInvoiceFromApi = (row) => {
  if (!row) return null;
  return {
    ...row,
    id: row.id,
    clientId: row.clientId != null ? String(row.clientId) : "",
    companyId: row.companyId != null ? String(row.companyId) : "",
  };
};

export const fetchInvoices = async () => {
  const response = await protectedApi({ url: APIS.INVOICE_MANAGEMENT, method: "GET" });
  const invoices = response?.data?.data?.invoices || [];
  return invoices.map(mapInvoiceFromApi).filter(Boolean);
};

export const createInvoiceApi = async (invoice) => {
  const response = await protectedApi({
    url: APIS.INVOICE_MANAGEMENT,
    method: "POST",
    data: invoice,
  });
  return mapInvoiceFromApi(response?.data?.data?.invoice);
};

export const updateInvoiceApi = async (invoiceId, invoice) => {
  const url = APIS.INVOICE_MANAGEMENT_BY_ID.replace(":invoiceId", String(invoiceId));
  const response = await protectedApi({
    url,
    method: "PUT",
    data: invoice,
  });
  return mapInvoiceFromApi(response?.data?.data?.invoice);
};

export const deleteInvoiceApi = async (invoiceId) => {
  const url = APIS.INVOICE_MANAGEMENT_BY_ID.replace(":invoiceId", String(invoiceId));
  await protectedApi({ url, method: "DELETE" });
};
